import script from "./Details.vue?vue&type=script&setup=true&lang=ts"
export * from "./Details.vue?vue&type=script&setup=true&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=503f6c78&lang=css"

export default script